import _slicedToArray from "/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _createForOfIteratorHelper from "/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _regeneratorRuntime from "/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(_syncBatch),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(syncBuffer),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(_syncConcat),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(_syncTake),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(_syncTime);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
function __values(o) {
  var m = typeof Symbol === "function" && o[Symbol.iterator],
      i = 0;
  if (m) return m.call(o);
  return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []),
      i,
      q = [];
  return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i;

  function verb(n) {
    if (g[n]) i[n] = function (v) {
      return new Promise(function (a, b) {
        q.push([n, v, a, b]) > 1 || resume(n, v);
      });
    };
  }

  function resume(n, v) {
    try {
      step(g[n](v));
    } catch (e) {
      settle(q[0][3], e);
    }
  }

  function step(r) {
    r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
  }

  function fulfill(value) {
    resume("next", value);
  }

  function reject(value) {
    resume("throw", value);
  }

  function settle(f, v) {
    if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
  }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) {
    throw e;
  }), verb("return"), i[Symbol.iterator] = function () {
    return this;
  }, i;

  function verb(n, f) {
    i[n] = o[n] ? function (v) {
      return (p = !p) ? {
        value: __await(o[n](v)),
        done: n === "return"
      } : f ? f(v) : v;
    } : f;
  }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator],
      i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () {
    return this;
  }, i);

  function verb(n) {
    i[n] = o[n] && function (v) {
      return new Promise(function (resolve, reject) {
        v = o[n](v), settle(resolve, reject, v.done, v.value);
      });
    };
  }

  function settle(resolve, reject, d, v) {
    Promise.resolve(v).then(function (v) {
      resolve({
        value: v,
        done: d
      });
    }, reject);
  }
}

function _batch(size, iterable) {
  return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _batch_1() {
    var e_1, _a, dataBatch, iterable_1, iterable_1_1, data;

    return _regeneratorRuntime.wrap(function _batch_1$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            dataBatch = [];
            _context.prev = 1;
            iterable_1 = __asyncValues(iterable);

          case 3:
            _context.next = 5;
            return __await(iterable_1.next());

          case 5:
            iterable_1_1 = _context.sent;

            if (iterable_1_1.done) {
              _context.next = 17;
              break;
            }

            data = iterable_1_1.value;
            dataBatch.push(data);

            if (!(dataBatch.length === size)) {
              _context.next = 15;
              break;
            }

            _context.next = 12;
            return __await(dataBatch);

          case 12:
            _context.next = 14;
            return _context.sent;

          case 14:
            dataBatch = [];

          case 15:
            _context.next = 3;
            break;

          case 17:
            _context.next = 22;
            break;

          case 19:
            _context.prev = 19;
            _context.t0 = _context["catch"](1);
            e_1 = {
              error: _context.t0
            };

          case 22:
            _context.prev = 22;
            _context.prev = 23;

            if (!(iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return))) {
              _context.next = 27;
              break;
            }

            _context.next = 27;
            return __await(_a.call(iterable_1));

          case 27:
            _context.prev = 27;

            if (!e_1) {
              _context.next = 30;
              break;
            }

            throw e_1.error;

          case 30:
            return _context.finish(27);

          case 31:
            return _context.finish(22);

          case 32:
            if (!(dataBatch.length > 0)) {
              _context.next = 37;
              break;
            }

            _context.next = 35;
            return __await(dataBatch);

          case 35:
            _context.next = 37;
            return _context.sent;

          case 37:
          case "end":
            return _context.stop();
        }
      }
    }, _batch_1, null, [[1, 19, 22, 32], [23,, 27, 31]]);
  }));
}

function _syncBatch(size, iterable) {
  var dataBatch, _iterator, _step, data;

  return _regeneratorRuntime.wrap(function _syncBatch$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          dataBatch = [];
          _iterator = _createForOfIteratorHelper(iterable);
          _context2.prev = 2;

          _iterator.s();

        case 4:
          if ((_step = _iterator.n()).done) {
            _context2.next = 13;
            break;
          }

          data = _step.value;
          dataBatch.push(data);

          if (!(dataBatch.length === size)) {
            _context2.next = 11;
            break;
          }

          _context2.next = 10;
          return dataBatch;

        case 10:
          dataBatch = [];

        case 11:
          _context2.next = 4;
          break;

        case 13:
          _context2.next = 18;
          break;

        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2["catch"](2);

          _iterator.e(_context2.t0);

        case 18:
          _context2.prev = 18;

          _iterator.f();

          return _context2.finish(18);

        case 21:
          if (!(dataBatch.length > 0)) {
            _context2.next = 24;
            break;
          }

          _context2.next = 24;
          return dataBatch;

        case 24:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked, null, [[2, 15, 18, 21]]);
}

function batch(size, iterable) {
  if (iterable === undefined) {
    return function (curriedIterable) {
      return batch(size, curriedIterable);
    };
  }

  if (iterable[Symbol.asyncIterator]) {
    return _batch(size, iterable);
  }

  return _syncBatch(size, iterable);
}

function getIterator(iterable) {
  if (typeof iterable.next === 'function') {
    return iterable;
  }

  if (typeof iterable[Symbol.iterator] === 'function') {
    return iterable[Symbol.iterator]();
  }

  if (typeof iterable[Symbol.asyncIterator] === 'function') {
    return iterable[Symbol.asyncIterator]();
  }

  throw new TypeError('"values" does not to conform to any of the iterator or iterable protocols');
}

function defer() {
  var reject;
  var resolve;
  var promise = new Promise(function (resolveFunc, rejectFunc) {
    resolve = resolveFunc;
    reject = rejectFunc;
  });
  return {
    promise: promise,
    reject: reject,
    resolve: resolve
  };
} /// <reference lib="esnext.asynciterable" />


function _buffer(size, iterable) {
  var iterator = getIterator(iterable);
  var resultQueue = [];
  var readQueue = [];
  var reading = false;
  var ended = false;

  function fulfillReadQueue() {
    while (readQueue.length > 0 && resultQueue.length > 0) {
      var readDeferred = readQueue.shift();

      var _resultQueue$shift = resultQueue.shift(),
          error = _resultQueue$shift.error,
          value = _resultQueue$shift.value;

      if (error) {
        readDeferred.reject(error);
      } else {
        readDeferred.resolve({
          done: false,
          value: value
        });
      }
    }

    while (readQueue.length > 0 && ended) {
      var _readQueue$shift = readQueue.shift(),
          resolve = _readQueue$shift.resolve;

      resolve({
        done: true,
        value: undefined
      });
    }
  }

  function fillQueue() {
    return _fillQueue.apply(this, arguments);
  }

  function _fillQueue() {
    _fillQueue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$iterator$next, done, value;

      return _regeneratorRuntime.wrap(function _callee$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!ended) {
                _context3.next = 2;
                break;
              }

              return _context3.abrupt("return");

            case 2:
              if (!reading) {
                _context3.next = 4;
                break;
              }

              return _context3.abrupt("return");

            case 4:
              if (!(resultQueue.length >= size)) {
                _context3.next = 6;
                break;
              }

              return _context3.abrupt("return");

            case 6:
              reading = true;
              _context3.prev = 7;
              _context3.next = 10;
              return iterator.next();

            case 10:
              _yield$iterator$next = _context3.sent;
              done = _yield$iterator$next.done;
              value = _yield$iterator$next.value;

              if (done) {
                ended = true;
              } else {
                resultQueue.push({
                  value: value
                });
              }

              _context3.next = 20;
              break;

            case 16:
              _context3.prev = 16;
              _context3.t0 = _context3["catch"](7);
              ended = true;
              resultQueue.push({
                error: _context3.t0
              });

            case 20:
              fulfillReadQueue();
              reading = false;
              fillQueue();

            case 23:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee, null, [[7, 16]]);
    }));
    return _fillQueue.apply(this, arguments);
  }

  function next() {
    return _next.apply(this, arguments);
  }

  function _next() {
    _next = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _resultQueue$shift2, error, value, deferred;

      return _regeneratorRuntime.wrap(function _callee2$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(resultQueue.length > 0)) {
                _context4.next = 6;
                break;
              }

              _resultQueue$shift2 = resultQueue.shift(), error = _resultQueue$shift2.error, value = _resultQueue$shift2.value;

              if (!error) {
                _context4.next = 4;
                break;
              }

              throw error;

            case 4:
              fillQueue();
              return _context4.abrupt("return", {
                done: false,
                value: value
              });

            case 6:
              if (!ended) {
                _context4.next = 8;
                break;
              }

              return _context4.abrupt("return", {
                done: true,
                value: undefined
              });

            case 8:
              deferred = defer();
              readQueue.push(deferred);
              fillQueue();
              return _context4.abrupt("return", deferred.promise);

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee2);
    }));
    return _next.apply(this, arguments);
  }

  var asyncIterableIterator = _defineProperty({
    next: next
  }, Symbol.asyncIterator, function () {
    return asyncIterableIterator;
  });

  return asyncIterableIterator;
}

function syncBuffer(size, iterable) {
  var valueQueue, e, _iterator2, _step2, value, _i, _valueQueue, _value;

  return _regeneratorRuntime.wrap(function syncBuffer$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          valueQueue = [];
          _context5.prev = 1;
          _iterator2 = _createForOfIteratorHelper(iterable);
          _context5.prev = 3;

          _iterator2.s();

        case 5:
          if ((_step2 = _iterator2.n()).done) {
            _context5.next = 14;
            break;
          }

          value = _step2.value;
          valueQueue.push(value);

          if (!(valueQueue.length <= size)) {
            _context5.next = 10;
            break;
          }

          return _context5.abrupt("continue", 12);

        case 10:
          _context5.next = 12;
          return valueQueue.shift();

        case 12:
          _context5.next = 5;
          break;

        case 14:
          _context5.next = 19;
          break;

        case 16:
          _context5.prev = 16;
          _context5.t0 = _context5["catch"](3);

          _iterator2.e(_context5.t0);

        case 19:
          _context5.prev = 19;

          _iterator2.f();

          return _context5.finish(19);

        case 22:
          _context5.next = 27;
          break;

        case 24:
          _context5.prev = 24;
          _context5.t1 = _context5["catch"](1);
          e = _context5.t1;

        case 27:
          _i = 0, _valueQueue = valueQueue;

        case 28:
          if (!(_i < _valueQueue.length)) {
            _context5.next = 35;
            break;
          }

          _value = _valueQueue[_i];
          _context5.next = 32;
          return _value;

        case 32:
          _i++;
          _context5.next = 28;
          break;

        case 35:
          if (!e) {
            _context5.next = 37;
            break;
          }

          throw e;

        case 37:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked2, null, [[1, 24], [3, 16, 19, 22]]);
}

function buffer(size, iterable) {
  if (iterable === undefined) {
    return function (curriedIterable) {
      return buffer(size, curriedIterable);
    };
  }

  if (iterable[Symbol.asyncIterator]) {
    return _buffer(size, iterable);
  }

  return syncBuffer(size, iterable);
}

function _collect(_x) {
  return _collect2.apply(this, arguments);
}

function _collect2() {
  _collect2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(iterable) {
    var e_1, _a, values, iterable_1, iterable_1_1, value;

    return _regeneratorRuntime.wrap(function _callee11$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            values = [];
            _context28.prev = 1;
            iterable_1 = __asyncValues(iterable);

          case 3:
            _context28.next = 5;
            return iterable_1.next();

          case 5:
            iterable_1_1 = _context28.sent;

            if (iterable_1_1.done) {
              _context28.next = 11;
              break;
            }

            value = iterable_1_1.value;
            values.push(value);

          case 9:
            _context28.next = 3;
            break;

          case 11:
            _context28.next = 16;
            break;

          case 13:
            _context28.prev = 13;
            _context28.t0 = _context28["catch"](1);
            e_1 = {
              error: _context28.t0
            };

          case 16:
            _context28.prev = 16;
            _context28.prev = 17;

            if (!(iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return))) {
              _context28.next = 21;
              break;
            }

            _context28.next = 21;
            return _a.call(iterable_1);

          case 21:
            _context28.prev = 21;

            if (!e_1) {
              _context28.next = 24;
              break;
            }

            throw e_1.error;

          case 24:
            return _context28.finish(21);

          case 25:
            return _context28.finish(16);

          case 26:
            return _context28.abrupt("return", values);

          case 27:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee11, null, [[1, 13, 16, 26], [17,, 21, 25]]);
  }));
  return _collect2.apply(this, arguments);
}

function collect(iterable) {
  if (iterable[Symbol.asyncIterator]) {
    return _collect(iterable);
  }

  return Array.from(iterable);
}

function _concat(iterables) {
  return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _concat_1() {
    var e_1, _a, iterables_1, iterables_1_1, iterable;

    return _regeneratorRuntime.wrap(function _concat_1$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            iterables_1 = __asyncValues(iterables);

          case 2:
            _context6.next = 4;
            return __await(iterables_1.next());

          case 4:
            iterables_1_1 = _context6.sent;

            if (iterables_1_1.done) {
              _context6.next = 14;
              break;
            }

            iterable = iterables_1_1.value;
            _context6.t0 = __await;
            return _context6.delegateYield(__asyncDelegator(__asyncValues(iterable)), "t1", 9);

          case 9:
            _context6.t2 = _context6.t1;
            _context6.next = 12;
            return (0, _context6.t0)(_context6.t2);

          case 12:
            _context6.next = 2;
            break;

          case 14:
            _context6.next = 19;
            break;

          case 16:
            _context6.prev = 16;
            _context6.t3 = _context6["catch"](0);
            e_1 = {
              error: _context6.t3
            };

          case 19:
            _context6.prev = 19;
            _context6.prev = 20;

            if (!(iterables_1_1 && !iterables_1_1.done && (_a = iterables_1.return))) {
              _context6.next = 24;
              break;
            }

            _context6.next = 24;
            return __await(_a.call(iterables_1));

          case 24:
            _context6.prev = 24;

            if (!e_1) {
              _context6.next = 27;
              break;
            }

            throw e_1.error;

          case 27:
            return _context6.finish(24);

          case 28:
            return _context6.finish(19);

          case 29:
          case "end":
            return _context6.stop();
        }
      }
    }, _concat_1, null, [[0, 16, 19, 29], [20,, 24, 28]]);
  }));
}

function _syncConcat(iterables) {
  var _iterator3, _step3, iterable;

  return _regeneratorRuntime.wrap(function _syncConcat$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _iterator3 = _createForOfIteratorHelper(iterables);
          _context7.prev = 1;

          _iterator3.s();

        case 3:
          if ((_step3 = _iterator3.n()).done) {
            _context7.next = 8;
            break;
          }

          iterable = _step3.value;
          return _context7.delegateYield(iterable, "t0", 6);

        case 6:
          _context7.next = 3;
          break;

        case 8:
          _context7.next = 13;
          break;

        case 10:
          _context7.prev = 10;
          _context7.t1 = _context7["catch"](1);

          _iterator3.e(_context7.t1);

        case 13:
          _context7.prev = 13;

          _iterator3.f();

          return _context7.finish(13);

        case 16:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked3, null, [[1, 10, 13, 16]]);
}

function concat() {
  for (var _len = arguments.length, iterables = new Array(_len), _key = 0; _key < _len; _key++) {
    iterables[_key] = arguments[_key];
  }

  var hasAnyAsync = iterables.find(function (itr) {
    return itr[Symbol.asyncIterator] !== undefined;
  });

  if (hasAnyAsync) {
    return _concat(iterables);
  } else {
    return _syncConcat(iterables);
  }
}

function _consume(_x2) {
  return _consume2.apply(this, arguments);
}

function _consume2() {
  _consume2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(iterable) {
    var e_1, _a, iterable_1, iterable_1_1, val;

    return _regeneratorRuntime.wrap(function _callee12$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            _context29.prev = 0;
            iterable_1 = __asyncValues(iterable);

          case 2:
            _context29.next = 4;
            return iterable_1.next();

          case 4:
            iterable_1_1 = _context29.sent;

            if (iterable_1_1.done) {
              _context29.next = 9;
              break;
            }

            val = iterable_1_1.value;

          case 7:
            _context29.next = 2;
            break;

          case 9:
            _context29.next = 14;
            break;

          case 11:
            _context29.prev = 11;
            _context29.t0 = _context29["catch"](0);
            e_1 = {
              error: _context29.t0
            };

          case 14:
            _context29.prev = 14;
            _context29.prev = 15;

            if (!(iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return))) {
              _context29.next = 19;
              break;
            }

            _context29.next = 19;
            return _a.call(iterable_1);

          case 19:
            _context29.prev = 19;

            if (!e_1) {
              _context29.next = 22;
              break;
            }

            throw e_1.error;

          case 22:
            return _context29.finish(19);

          case 23:
            return _context29.finish(14);

          case 24:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee12, null, [[0, 11, 14, 24], [15,, 19, 23]]);
  }));
  return _consume2.apply(this, arguments);
}

function consume(iterable) {
  if (iterable[Symbol.asyncIterator]) {
    return _consume(iterable);
  }
}

function _filter(filterFunc, iterable) {
  return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _filter_1() {
    var e_1, _a, iterable_1, iterable_1_1, data;

    return _regeneratorRuntime.wrap(function _filter_1$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            iterable_1 = __asyncValues(iterable);

          case 2:
            _context8.next = 4;
            return __await(iterable_1.next());

          case 4:
            iterable_1_1 = _context8.sent;

            if (iterable_1_1.done) {
              _context8.next = 16;
              break;
            }

            data = iterable_1_1.value;
            _context8.next = 9;
            return __await(filterFunc(data));

          case 9:
            if (!_context8.sent) {
              _context8.next = 14;
              break;
            }

            _context8.next = 12;
            return __await(data);

          case 12:
            _context8.next = 14;
            return _context8.sent;

          case 14:
            _context8.next = 2;
            break;

          case 16:
            _context8.next = 21;
            break;

          case 18:
            _context8.prev = 18;
            _context8.t0 = _context8["catch"](0);
            e_1 = {
              error: _context8.t0
            };

          case 21:
            _context8.prev = 21;
            _context8.prev = 22;

            if (!(iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return))) {
              _context8.next = 26;
              break;
            }

            _context8.next = 26;
            return __await(_a.call(iterable_1));

          case 26:
            _context8.prev = 26;

            if (!e_1) {
              _context8.next = 29;
              break;
            }

            throw e_1.error;

          case 29:
            return _context8.finish(26);

          case 30:
            return _context8.finish(21);

          case 31:
          case "end":
            return _context8.stop();
        }
      }
    }, _filter_1, null, [[0, 18, 21, 31], [22,, 26, 30]]);
  }));
}

function filter(filterFunc, iterable) {
  if (iterable === undefined) {
    return function (curriedIterable) {
      return _filter(filterFunc, curriedIterable);
    };
  }

  return _filter(filterFunc, iterable);
}

function flatten(iterable) {
  return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function flatten_1() {
    var e_1, _a, iterable_1, iterable_1_1, maybeItr;

    return _regeneratorRuntime.wrap(function flatten_1$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            iterable_1 = __asyncValues(iterable);

          case 2:
            _context9.next = 4;
            return __await(iterable_1.next());

          case 4:
            iterable_1_1 = _context9.sent;

            if (iterable_1_1.done) {
              _context9.next = 21;
              break;
            }

            maybeItr = iterable_1_1.value;

            if (!(maybeItr && typeof maybeItr !== 'string' && (maybeItr[Symbol.iterator] || maybeItr[Symbol.asyncIterator]))) {
              _context9.next = 15;
              break;
            }

            _context9.t0 = __await;
            return _context9.delegateYield(__asyncDelegator(__asyncValues(flatten(maybeItr))), "t1", 10);

          case 10:
            _context9.t2 = _context9.t1;
            _context9.next = 13;
            return (0, _context9.t0)(_context9.t2);

          case 13:
            _context9.next = 19;
            break;

          case 15:
            _context9.next = 17;
            return __await(maybeItr);

          case 17:
            _context9.next = 19;
            return _context9.sent;

          case 19:
            _context9.next = 2;
            break;

          case 21:
            _context9.next = 26;
            break;

          case 23:
            _context9.prev = 23;
            _context9.t3 = _context9["catch"](0);
            e_1 = {
              error: _context9.t3
            };

          case 26:
            _context9.prev = 26;
            _context9.prev = 27;

            if (!(iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return))) {
              _context9.next = 31;
              break;
            }

            _context9.next = 31;
            return __await(_a.call(iterable_1));

          case 31:
            _context9.prev = 31;

            if (!e_1) {
              _context9.next = 34;
              break;
            }

            throw e_1.error;

          case 34:
            return _context9.finish(31);

          case 35:
            return _context9.finish(26);

          case 36:
          case "end":
            return _context9.stop();
        }
      }
    }, flatten_1, null, [[0, 23, 26, 36], [27,, 31, 35]]);
  }));
}

function _map(func, iterable) {
  return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _map_1() {
    var e_1, _a, iterable_1, iterable_1_1, val;

    return _regeneratorRuntime.wrap(function _map_1$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            iterable_1 = __asyncValues(iterable);

          case 2:
            _context10.next = 4;
            return __await(iterable_1.next());

          case 4:
            iterable_1_1 = _context10.sent;

            if (iterable_1_1.done) {
              _context10.next = 17;
              break;
            }

            val = iterable_1_1.value;
            _context10.t0 = __await;
            _context10.next = 10;
            return __await(func(val));

          case 10:
            _context10.t1 = _context10.sent;
            _context10.next = 13;
            return (0, _context10.t0)(_context10.t1);

          case 13:
            _context10.next = 15;
            return _context10.sent;

          case 15:
            _context10.next = 2;
            break;

          case 17:
            _context10.next = 22;
            break;

          case 19:
            _context10.prev = 19;
            _context10.t2 = _context10["catch"](0);
            e_1 = {
              error: _context10.t2
            };

          case 22:
            _context10.prev = 22;
            _context10.prev = 23;

            if (!(iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return))) {
              _context10.next = 27;
              break;
            }

            _context10.next = 27;
            return __await(_a.call(iterable_1));

          case 27:
            _context10.prev = 27;

            if (!e_1) {
              _context10.next = 30;
              break;
            }

            throw e_1.error;

          case 30:
            return _context10.finish(27);

          case 31:
            return _context10.finish(22);

          case 32:
          case "end":
            return _context10.stop();
        }
      }
    }, _map_1, null, [[0, 19, 22, 32], [23,, 27, 31]]);
  }));
}

function map(func, iterable) {
  if (iterable === undefined) {
    return function (curriedIterable) {
      return _map(func, curriedIterable);
    };
  }

  return _map(func, iterable);
}

function flatMap(func, iterable) {
  if (iterable === undefined) {
    return function (curriedIterable) {
      return flatMap(func, curriedIterable);
    };
  }

  return filter(function (i) {
    return i !== undefined && i !== null;
  }, flatten(map(func, iterable)));
}

function _flatTransform(concurrency, func, iterable) {
  var iterator = getIterator(iterable);
  var resultQueue = [];
  var readQueue = [];
  var ended = false;
  var reading = false;
  var inflightCount = 0;
  var lastError = null;

  function fulfillReadQueue() {
    while (readQueue.length > 0 && resultQueue.length > 0) {
      var _readQueue$shift2 = readQueue.shift(),
          resolve = _readQueue$shift2.resolve;

      var value = resultQueue.shift();
      resolve({
        done: false,
        value: value
      });
    }

    while (readQueue.length > 0 && inflightCount === 0 && ended) {
      var _readQueue$shift3 = readQueue.shift(),
          _resolve = _readQueue$shift3.resolve,
          reject = _readQueue$shift3.reject;

      if (lastError) {
        reject(lastError);
        lastError = null;
      } else {
        _resolve({
          done: true,
          value: undefined
        });
      }
    }
  }

  function fillQueue() {
    return _fillQueue2.apply(this, arguments);
  }

  function _fillQueue2() {
    _fillQueue2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var _yield$iterator$next2, done, value;

      return _regeneratorRuntime.wrap(function _callee3$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              if (!ended) {
                _context11.next = 3;
                break;
              }

              fulfillReadQueue();
              return _context11.abrupt("return");

            case 3:
              if (!reading) {
                _context11.next = 5;
                break;
              }

              return _context11.abrupt("return");

            case 5:
              if (!(inflightCount + resultQueue.length >= concurrency)) {
                _context11.next = 7;
                break;
              }

              return _context11.abrupt("return");

            case 7:
              reading = true;
              inflightCount++;
              _context11.prev = 9;
              _context11.next = 12;
              return iterator.next();

            case 12:
              _yield$iterator$next2 = _context11.sent;
              done = _yield$iterator$next2.done;
              value = _yield$iterator$next2.value;

              if (done) {
                ended = true;
                inflightCount--;
                fulfillReadQueue();
              } else {
                mapAndQueue(value);
              }

              _context11.next = 24;
              break;

            case 18:
              _context11.prev = 18;
              _context11.t0 = _context11["catch"](9);
              ended = true;
              inflightCount--;
              lastError = _context11.t0;
              fulfillReadQueue();

            case 24:
              reading = false;
              fillQueue();

            case 26:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee3, null, [[9, 18]]);
    }));
    return _fillQueue2.apply(this, arguments);
  }

  function mapAndQueue(_x3) {
    return _mapAndQueue.apply(this, arguments);
  }

  function _mapAndQueue() {
    _mapAndQueue = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(itrValue) {
      var e_1, _a, value, _b, _c, asyncVal;

      return _regeneratorRuntime.wrap(function _callee4$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.prev = 0;
              _context12.next = 3;
              return func(itrValue);

            case 3:
              value = _context12.sent;

              if (!(value && value[Symbol.asyncIterator])) {
                _context12.next = 32;
                break;
              }

              _context12.prev = 5;
              _b = __asyncValues(value);

            case 7:
              _context12.next = 9;
              return _b.next();

            case 9:
              _c = _context12.sent;

              if (_c.done) {
                _context12.next = 15;
                break;
              }

              asyncVal = _c.value;
              resultQueue.push(asyncVal);

            case 13:
              _context12.next = 7;
              break;

            case 15:
              _context12.next = 20;
              break;

            case 17:
              _context12.prev = 17;
              _context12.t0 = _context12["catch"](5);
              e_1 = {
                error: _context12.t0
              };

            case 20:
              _context12.prev = 20;
              _context12.prev = 21;

              if (!(_c && !_c.done && (_a = _b.return))) {
                _context12.next = 25;
                break;
              }

              _context12.next = 25;
              return _a.call(_b);

            case 25:
              _context12.prev = 25;

              if (!e_1) {
                _context12.next = 28;
                break;
              }

              throw e_1.error;

            case 28:
              return _context12.finish(25);

            case 29:
              return _context12.finish(20);

            case 30:
              _context12.next = 33;
              break;

            case 32:
              resultQueue.push(value);

            case 33:
              _context12.next = 39;
              break;

            case 35:
              _context12.prev = 35;
              _context12.t1 = _context12["catch"](0);
              ended = true;
              lastError = _context12.t1;

            case 39:
              inflightCount--;
              fulfillReadQueue();
              fillQueue();

            case 42:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee4, null, [[0, 35], [5, 17, 20, 30], [21,, 25, 29]]);
    }));
    return _mapAndQueue.apply(this, arguments);
  }

  function next() {
    return _next2.apply(this, arguments);
  }

  function _next2() {
    _next2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      var deferred, value;
      return _regeneratorRuntime.wrap(function _callee5$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              if (!(resultQueue.length === 0)) {
                _context13.next = 5;
                break;
              }

              deferred = defer();
              readQueue.push(deferred);
              fillQueue();
              return _context13.abrupt("return", deferred.promise);

            case 5:
              value = resultQueue.shift();
              fillQueue();
              return _context13.abrupt("return", {
                done: false,
                value: value
              });

            case 8:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee5);
    }));
    return _next2.apply(this, arguments);
  }

  var asyncIterableIterator = _defineProperty({
    next: next
  }, Symbol.asyncIterator, function () {
    return asyncIterableIterator;
  });

  return asyncIterableIterator;
}

function flatTransform(concurrency, func, iterable) {
  if (func === undefined) {
    return function (curriedFunc, curriedIterable) {
      return curriedIterable ? flatTransform(concurrency, curriedFunc, curriedIterable) : flatTransform(concurrency, curriedFunc);
    };
  }

  if (iterable === undefined) {
    return function (curriedIterable) {
      return flatTransform(concurrency, func, curriedIterable);
    };
  }

  return filter(function (i) {
    return i !== undefined && i !== null;
  }, flatten(_flatTransform(concurrency, func, iterable)));
}

function onceReadable(_x4) {
  return _onceReadable.apply(this, arguments);
}

function _onceReadable() {
  _onceReadable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(stream) {
    return _regeneratorRuntime.wrap(function _callee13$(_context30) {
      while (1) {
        switch (_context30.prev = _context30.next) {
          case 0:
            return _context30.abrupt("return", new Promise(function (resolve) {
              stream.once('readable', function () {
                resolve();
              });
            }));

          case 1:
          case "end":
            return _context30.stop();
        }
      }
    }, _callee13);
  }));
  return _onceReadable.apply(this, arguments);
}

function _fromStream(stream) {
  return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _fromStream_1() {
    var data;
    return _regeneratorRuntime.wrap(function _fromStream_1$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            if (!true) {
              _context14.next = 16;
              break;
            }

            data = stream.read();

            if (!(data !== null)) {
              _context14.next = 8;
              break;
            }

            _context14.next = 5;
            return __await(data);

          case 5:
            _context14.next = 7;
            return _context14.sent;

          case 7:
            return _context14.abrupt("continue", 0);

          case 8:
            if (!stream._readableState.ended) {
              _context14.next = 12;
              break;
            }

            _context14.next = 11;
            return __await(void 0);

          case 11:
            return _context14.abrupt("return", _context14.sent);

          case 12:
            _context14.next = 14;
            return __await(onceReadable(stream));

          case 14:
            _context14.next = 0;
            break;

          case 16:
          case "end":
            return _context14.stop();
        }
      }
    }, _fromStream_1);
  }));
}

function fromStream(stream) {
  if (typeof stream[Symbol.asyncIterator] === 'function') {
    return stream;
  }

  return _fromStream(stream);
}

function merge() {
  for (var _len2 = arguments.length, iterables = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    iterables[_key2] = arguments[_key2];
  }

  return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function merge_1() {
    var sources, _iterator4, _step4, iterator, nextVal;

    return _regeneratorRuntime.wrap(function merge_1$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            sources = new Set(iterables.map(getIterator));

          case 1:
            if (!(sources.size > 0)) {
              _context15.next = 30;
              break;
            }

            _iterator4 = _createForOfIteratorHelper(sources);
            _context15.prev = 3;

            _iterator4.s();

          case 5:
            if ((_step4 = _iterator4.n()).done) {
              _context15.next = 20;
              break;
            }

            iterator = _step4.value;
            _context15.next = 9;
            return __await(iterator.next());

          case 9:
            nextVal = _context15.sent;

            if (!nextVal.done) {
              _context15.next = 14;
              break;
            }

            sources.delete(iterator);
            _context15.next = 18;
            break;

          case 14:
            _context15.next = 16;
            return __await(nextVal.value);

          case 16:
            _context15.next = 18;
            return _context15.sent;

          case 18:
            _context15.next = 5;
            break;

          case 20:
            _context15.next = 25;
            break;

          case 22:
            _context15.prev = 22;
            _context15.t0 = _context15["catch"](3);

            _iterator4.e(_context15.t0);

          case 25:
            _context15.prev = 25;

            _iterator4.f();

            return _context15.finish(25);

          case 28:
            _context15.next = 1;
            break;

          case 30:
          case "end":
            return _context15.stop();
        }
      }
    }, merge_1, null, [[3, 22, 25, 28]]);
  }));
}

function pipeline(firstFn) {
  var previousFn = firstFn();

  for (var _len3 = arguments.length, fns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    fns[_key3 - 1] = arguments[_key3];
  }

  for (var _i2 = 0, _fns = fns; _i2 < _fns.length; _i2++) {
    var func = _fns[_i2];
    previousFn = func(previousFn);
  }

  return previousFn;
}

function _parallelMap(concurrency, func, iterable) {
  return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _parallelMap_1() {
    var transformError, wrapFunc, stopOnError, output, itr, _yield$__await, value, done, val;

    return _regeneratorRuntime.wrap(function _parallelMap_1$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            transformError = null;

            wrapFunc = function wrapFunc(value) {
              return {
                value: func(value)
              };
            };

            stopOnError = function stopOnError(source) {
              return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                var e_1, _a, source_1, source_1_1, value;

                return _regeneratorRuntime.wrap(function _callee6$(_context16) {
                  while (1) {
                    switch (_context16.prev = _context16.next) {
                      case 0:
                        _context16.prev = 0;
                        source_1 = __asyncValues(source);

                      case 2:
                        _context16.next = 4;
                        return __await(source_1.next());

                      case 4:
                        source_1_1 = _context16.sent;

                        if (source_1_1.done) {
                          _context16.next = 17;
                          break;
                        }

                        value = source_1_1.value;

                        if (!transformError) {
                          _context16.next = 11;
                          break;
                        }

                        _context16.next = 10;
                        return __await(void 0);

                      case 10:
                        return _context16.abrupt("return", _context16.sent);

                      case 11:
                        _context16.next = 13;
                        return __await(value);

                      case 13:
                        _context16.next = 15;
                        return _context16.sent;

                      case 15:
                        _context16.next = 2;
                        break;

                      case 17:
                        _context16.next = 22;
                        break;

                      case 19:
                        _context16.prev = 19;
                        _context16.t0 = _context16["catch"](0);
                        e_1 = {
                          error: _context16.t0
                        };

                      case 22:
                        _context16.prev = 22;
                        _context16.prev = 23;

                        if (!(source_1_1 && !source_1_1.done && (_a = source_1.return))) {
                          _context16.next = 27;
                          break;
                        }

                        _context16.next = 27;
                        return __await(_a.call(source_1));

                      case 27:
                        _context16.prev = 27;

                        if (!e_1) {
                          _context16.next = 30;
                          break;
                        }

                        throw e_1.error;

                      case 30:
                        return _context16.finish(27);

                      case 31:
                        return _context16.finish(22);

                      case 32:
                      case "end":
                        return _context16.stop();
                    }
                  }
                }, _callee6, null, [[0, 19, 22, 32], [23,, 27, 31]]);
              }));
            };

            output = pipeline(function () {
              return iterable;
            }, buffer(1), stopOnError, map(wrapFunc), buffer(concurrency));
            itr = getIterator(output);

          case 5:
            if (!true) {
              _context17.next = 29;
              break;
            }

            _context17.next = 8;
            return __await(itr.next());

          case 8:
            _yield$__await = _context17.sent;
            value = _yield$__await.value;
            done = _yield$__await.done;

            if (!done) {
              _context17.next = 13;
              break;
            }

            return _context17.abrupt("break", 29);

          case 13:
            _context17.prev = 13;
            _context17.next = 16;
            return __await(value.value);

          case 16:
            val = _context17.sent;

            if (transformError) {
              _context17.next = 22;
              break;
            }

            _context17.next = 20;
            return __await(val);

          case 20:
            _context17.next = 22;
            return _context17.sent;

          case 22:
            _context17.next = 27;
            break;

          case 24:
            _context17.prev = 24;
            _context17.t0 = _context17["catch"](13);
            transformError = _context17.t0;

          case 27:
            _context17.next = 5;
            break;

          case 29:
            if (!transformError) {
              _context17.next = 31;
              break;
            }

            throw transformError;

          case 31:
          case "end":
            return _context17.stop();
        }
      }
    }, _parallelMap_1, null, [[13, 24]]);
  }));
}

function parallelMap(concurrency, func, iterable) {
  if (func === undefined) {
    return function (curriedFunc, curriedIterable) {
      return parallelMap(concurrency, curriedFunc, curriedIterable);
    };
  }

  if (iterable === undefined) {
    return function (curriedIterable) {
      return parallelMap(concurrency, func, curriedIterable);
    };
  }

  return _parallelMap(concurrency, func, iterable);
}

function parallelFlatMap(concurrency, func, iterable) {
  if (func === undefined) {
    return function (curriedFunc, curriedIterable) {
      return curriedIterable ? parallelFlatMap(concurrency, curriedFunc, curriedIterable) : parallelFlatMap(concurrency, curriedFunc);
    };
  }

  if (iterable === undefined) {
    return function (curriedIterable) {
      return parallelFlatMap(concurrency, func, curriedIterable);
    };
  }

  return filter(function (i) {
    return i !== undefined && i !== null;
  }, flatten(parallelMap(concurrency, func, iterable)));
}

function parallelMerge() {
  for (var _len4 = arguments.length, iterables = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    iterables[_key4] = arguments[_key4];
  }

  return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function parallelMerge_1() {
    var inputs, concurrentWork, values, lastError, errCb, valueCb, notifyError, notifyDone, waitForQueue, queueNext, _iterator5, _step5, _input, _iterator6, _step6, _step6$value, input, value;

    return _regeneratorRuntime.wrap(function parallelMerge_1$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            inputs = iterables.map(getIterator);
            concurrentWork = new Set();
            values = new Map();
            lastError = null;
            errCb = null;
            valueCb = null;

            notifyError = function notifyError(err) {
              lastError = err;

              if (errCb) {
                errCb(err);
              }
            };

            notifyDone = function notifyDone(value) {
              if (valueCb) {
                valueCb(value);
              }
            };

            waitForQueue = function waitForQueue() {
              return new Promise(function (resolve, reject) {
                if (lastError) {
                  reject(lastError);
                }

                if (values.size > 0) {
                  return resolve();
                }

                valueCb = resolve;
                errCb = reject;
              });
            };

            queueNext = function queueNext(input) {
              var nextVal = Promise.resolve(input.next()).then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref) {
                  var done, value;
                  return _regeneratorRuntime.wrap(function _callee7$(_context18) {
                    while (1) {
                      switch (_context18.prev = _context18.next) {
                        case 0:
                          done = _ref.done, value = _ref.value;

                          if (!done) {
                            values.set(input, value);
                          }

                          concurrentWork.delete(nextVal);

                        case 3:
                        case "end":
                          return _context18.stop();
                      }
                    }
                  }, _callee7);
                }));

                return function (_x5) {
                  return _ref2.apply(this, arguments);
                };
              }());
              concurrentWork.add(nextVal);
              nextVal.then(notifyDone, notifyError);
            };

            _iterator5 = _createForOfIteratorHelper(inputs);

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                _input = _step5.value;
                queueNext(_input);
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }

          case 12:
            if (!true) {
              _context19.next = 42;
              break;
            }

            if (!(concurrentWork.size === 0 && values.size === 0)) {
              _context19.next = 17;
              break;
            }

            _context19.next = 16;
            return __await(void 0);

          case 16:
            return _context19.abrupt("return", _context19.sent);

          case 17:
            _context19.next = 19;
            return __await(waitForQueue());

          case 19:
            _iterator6 = _createForOfIteratorHelper(values);
            _context19.prev = 20;

            _iterator6.s();

          case 22:
            if ((_step6 = _iterator6.n()).done) {
              _context19.next = 32;
              break;
            }

            _step6$value = _slicedToArray(_step6.value, 2), input = _step6$value[0], value = _step6$value[1];
            values.delete(input);
            _context19.next = 27;
            return __await(value);

          case 27:
            _context19.next = 29;
            return _context19.sent;

          case 29:
            queueNext(input);

          case 30:
            _context19.next = 22;
            break;

          case 32:
            _context19.next = 37;
            break;

          case 34:
            _context19.prev = 34;
            _context19.t0 = _context19["catch"](20);

            _iterator6.e(_context19.t0);

          case 37:
            _context19.prev = 37;

            _iterator6.f();

            return _context19.finish(37);

          case 40:
            _context19.next = 12;
            break;

          case 42:
          case "end":
            return _context19.stop();
        }
      }
    }, parallelMerge_1, null, [[20, 34, 37, 40]]);
  }));
}

function _reduce(_x6, _x7, _x8) {
  return _reduce2.apply(this, arguments);
}

function _reduce2() {
  _reduce2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(func, start, iterable) {
    var e_1, _a, value, iterable_1, iterable_1_1, nextItem;

    return _regeneratorRuntime.wrap(function _callee14$(_context31) {
      while (1) {
        switch (_context31.prev = _context31.next) {
          case 0:
            value = start;
            _context31.prev = 1;
            iterable_1 = __asyncValues(iterable);

          case 3:
            _context31.next = 5;
            return iterable_1.next();

          case 5:
            iterable_1_1 = _context31.sent;

            if (iterable_1_1.done) {
              _context31.next = 13;
              break;
            }

            nextItem = iterable_1_1.value;
            _context31.next = 10;
            return func(value, nextItem);

          case 10:
            value = _context31.sent;

          case 11:
            _context31.next = 3;
            break;

          case 13:
            _context31.next = 18;
            break;

          case 15:
            _context31.prev = 15;
            _context31.t0 = _context31["catch"](1);
            e_1 = {
              error: _context31.t0
            };

          case 18:
            _context31.prev = 18;
            _context31.prev = 19;

            if (!(iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return))) {
              _context31.next = 23;
              break;
            }

            _context31.next = 23;
            return _a.call(iterable_1);

          case 23:
            _context31.prev = 23;

            if (!e_1) {
              _context31.next = 26;
              break;
            }

            throw e_1.error;

          case 26:
            return _context31.finish(23);

          case 27:
            return _context31.finish(18);

          case 28:
            return _context31.abrupt("return", value);

          case 29:
          case "end":
            return _context31.stop();
        }
      }
    }, _callee14, null, [[1, 15, 18, 28], [19,, 23, 27]]);
  }));
  return _reduce2.apply(this, arguments);
}

function reduce(func, start, iterable) {
  if (start === undefined) {
    return function (curriedStart, curriedIterable) {
      return curriedIterable ? reduce(func, curriedStart, curriedIterable) : reduce(func, curriedStart);
    };
  }

  if (iterable === undefined) {
    return function (curriedIterable) {
      return reduce(func, start, curriedIterable);
    };
  }

  return _reduce(func, start, iterable);
}

function _take(count, iterable) {
  return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _take_1() {
    var e_1, _a, taken, iterable_1, iterable_1_1, val;

    return _regeneratorRuntime.wrap(function _take_1$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            taken = 0;
            _context20.prev = 1;
            iterable_1 = __asyncValues(iterable);

          case 3:
            _context20.next = 5;
            return __await(iterable_1.next());

          case 5:
            iterable_1_1 = _context20.sent;

            if (iterable_1_1.done) {
              _context20.next = 23;
              break;
            }

            val = iterable_1_1.value;
            _context20.t0 = __await;
            _context20.next = 11;
            return __await(val);

          case 11:
            _context20.t1 = _context20.sent;
            _context20.next = 14;
            return (0, _context20.t0)(_context20.t1);

          case 14:
            _context20.next = 16;
            return _context20.sent;

          case 16:
            taken++;

            if (!(taken >= count)) {
              _context20.next = 21;
              break;
            }

            _context20.next = 20;
            return __await(void 0);

          case 20:
            return _context20.abrupt("return", _context20.sent);

          case 21:
            _context20.next = 3;
            break;

          case 23:
            _context20.next = 28;
            break;

          case 25:
            _context20.prev = 25;
            _context20.t2 = _context20["catch"](1);
            e_1 = {
              error: _context20.t2
            };

          case 28:
            _context20.prev = 28;
            _context20.prev = 29;

            if (!(iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return))) {
              _context20.next = 33;
              break;
            }

            _context20.next = 33;
            return __await(_a.call(iterable_1));

          case 33:
            _context20.prev = 33;

            if (!e_1) {
              _context20.next = 36;
              break;
            }

            throw e_1.error;

          case 36:
            return _context20.finish(33);

          case 37:
            return _context20.finish(28);

          case 38:
          case "end":
            return _context20.stop();
        }
      }
    }, _take_1, null, [[1, 25, 28, 38], [29,, 33, 37]]);
  }));
}

function _syncTake(count, iterable) {
  var taken, _iterator7, _step7, val;

  return _regeneratorRuntime.wrap(function _syncTake$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          taken = 0;
          _iterator7 = _createForOfIteratorHelper(iterable);
          _context21.prev = 2;

          _iterator7.s();

        case 4:
          if ((_step7 = _iterator7.n()).done) {
            _context21.next = 13;
            break;
          }

          val = _step7.value;
          _context21.next = 8;
          return val;

        case 8:
          taken++;

          if (!(taken >= count)) {
            _context21.next = 11;
            break;
          }

          return _context21.abrupt("return");

        case 11:
          _context21.next = 4;
          break;

        case 13:
          _context21.next = 18;
          break;

        case 15:
          _context21.prev = 15;
          _context21.t0 = _context21["catch"](2);

          _iterator7.e(_context21.t0);

        case 18:
          _context21.prev = 18;

          _iterator7.f();

          return _context21.finish(18);

        case 21:
        case "end":
          return _context21.stop();
      }
    }
  }, _marked4, null, [[2, 15, 18, 21]]);
}

function take(count, iterable) {
  if (iterable === undefined) {
    return function (curriedIterable) {
      return take(count, curriedIterable);
    };
  }

  if (iterable[Symbol.asyncIterator]) {
    return _take(count, iterable);
  }

  return _syncTake(count, iterable);
}

function _asyncTap(func, iterable) {
  return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _asyncTap_1() {
    var e_1, _a, iterable_1, iterable_1_1, val;

    return _regeneratorRuntime.wrap(function _asyncTap_1$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            _context22.prev = 0;
            iterable_1 = __asyncValues(iterable);

          case 2:
            _context22.next = 4;
            return __await(iterable_1.next());

          case 4:
            iterable_1_1 = _context22.sent;

            if (iterable_1_1.done) {
              _context22.next = 15;
              break;
            }

            val = iterable_1_1.value;
            _context22.next = 9;
            return __await(func(val));

          case 9:
            _context22.next = 11;
            return __await(val);

          case 11:
            _context22.next = 13;
            return _context22.sent;

          case 13:
            _context22.next = 2;
            break;

          case 15:
            _context22.next = 20;
            break;

          case 17:
            _context22.prev = 17;
            _context22.t0 = _context22["catch"](0);
            e_1 = {
              error: _context22.t0
            };

          case 20:
            _context22.prev = 20;
            _context22.prev = 21;

            if (!(iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return))) {
              _context22.next = 25;
              break;
            }

            _context22.next = 25;
            return __await(_a.call(iterable_1));

          case 25:
            _context22.prev = 25;

            if (!e_1) {
              _context22.next = 28;
              break;
            }

            throw e_1.error;

          case 28:
            return _context22.finish(25);

          case 29:
            return _context22.finish(20);

          case 30:
          case "end":
            return _context22.stop();
        }
      }
    }, _asyncTap_1, null, [[0, 17, 20, 30], [21,, 25, 29]]);
  }));
}

function tap(func, iterable) {
  if (iterable === undefined) {
    return function (curriedIterable) {
      return _asyncTap(func, curriedIterable);
    };
  }

  return _asyncTap(func, iterable);
}

function addTime(a, b) {
  var seconds = a[0] + b[0];
  var nanoseconds = a[1] + b[1];

  if (nanoseconds >= 1000000000) {
    var remainder = nanoseconds % 1000000000;
    seconds += (nanoseconds - remainder) / 1000000000;
    nanoseconds = remainder;
  }

  return [seconds, nanoseconds];
}

function _asyncTime(config, iterable) {
  return __asyncGenerator(this, arguments, /*#__PURE__*/_regeneratorRuntime.mark(function _asyncTime_1() {
    var itr, total, start, _yield$__await2, value, done, delta;

    return _regeneratorRuntime.wrap(function _asyncTime_1$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            itr = iterable[Symbol.asyncIterator]();
            total = [0, 0];

          case 2:
            if (!true) {
              _context23.next = 23;
              break;
            }

            start = process.hrtime();
            _context23.next = 6;
            return __await(itr.next());

          case 6:
            _yield$__await2 = _context23.sent;
            value = _yield$__await2.value;
            done = _yield$__await2.done;
            delta = process.hrtime(start);
            total = addTime(total, delta);

            if (config.progress) {
              config.progress(delta, total);
            }

            if (!done) {
              _context23.next = 17;
              break;
            }

            if (config.total) {
              config.total(total);
            }

            _context23.next = 16;
            return __await(value);

          case 16:
            return _context23.abrupt("return", _context23.sent);

          case 17:
            _context23.next = 19;
            return __await(value);

          case 19:
            _context23.next = 21;
            return _context23.sent;

          case 21:
            _context23.next = 2;
            break;

          case 23:
          case "end":
            return _context23.stop();
        }
      }
    }, _asyncTime_1);
  }));
}

function _syncTime(config, iterable) {
  var itr, total, start, _itr$next, value, done, delta;

  return _regeneratorRuntime.wrap(function _syncTime$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          itr = iterable[Symbol.iterator]();
          total = [0, 0];

        case 2:
          if (!true) {
            _context24.next = 15;
            break;
          }

          start = process.hrtime();
          _itr$next = itr.next(), value = _itr$next.value, done = _itr$next.done;
          delta = process.hrtime(start);
          total = addTime(total, delta);

          if (config.progress) {
            config.progress(delta, total);
          }

          if (!done) {
            _context24.next = 11;
            break;
          }

          if (config.total) {
            config.total(total);
          }

          return _context24.abrupt("return", value);

        case 11:
          _context24.next = 13;
          return value;

        case 13:
          _context24.next = 2;
          break;

        case 15:
        case "end":
          return _context24.stop();
      }
    }
  }, _marked5);
}

function time() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var iterable = arguments.length > 1 ? arguments[1] : undefined;

  if (iterable === undefined) {
    return function (curriedIterable) {
      return time(config, curriedIterable);
    };
  }

  if (iterable[Symbol.asyncIterator] !== undefined) {
    return _asyncTime(config, iterable);
  } else {
    return _syncTime(config, iterable);
  }
}

function _transform(concurrency, func, iterable) {
  var iterator = getIterator(iterable);
  var resultQueue = [];
  var readQueue = [];
  var ended = false;
  var reading = false;
  var inflightCount = 0;
  var lastError = null;

  function fulfillReadQueue() {
    while (readQueue.length > 0 && resultQueue.length > 0) {
      var _readQueue$shift4 = readQueue.shift(),
          resolve = _readQueue$shift4.resolve;

      var value = resultQueue.shift();
      resolve({
        done: false,
        value: value
      });
    }

    while (readQueue.length > 0 && inflightCount === 0 && ended) {
      var _readQueue$shift5 = readQueue.shift(),
          _resolve2 = _readQueue$shift5.resolve,
          reject = _readQueue$shift5.reject;

      if (lastError) {
        reject(lastError);
        lastError = null;
      } else {
        _resolve2({
          done: true,
          value: undefined
        });
      }
    }
  }

  function fillQueue() {
    return _fillQueue3.apply(this, arguments);
  }

  function _fillQueue3() {
    _fillQueue3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
      var _yield$iterator$next3, done, value;

      return _regeneratorRuntime.wrap(function _callee8$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              if (!ended) {
                _context25.next = 3;
                break;
              }

              fulfillReadQueue();
              return _context25.abrupt("return");

            case 3:
              if (!reading) {
                _context25.next = 5;
                break;
              }

              return _context25.abrupt("return");

            case 5:
              if (!(inflightCount + resultQueue.length >= concurrency)) {
                _context25.next = 7;
                break;
              }

              return _context25.abrupt("return");

            case 7:
              reading = true;
              inflightCount++;
              _context25.prev = 9;
              _context25.next = 12;
              return iterator.next();

            case 12:
              _yield$iterator$next3 = _context25.sent;
              done = _yield$iterator$next3.done;
              value = _yield$iterator$next3.value;

              if (done) {
                ended = true;
                inflightCount--;
                fulfillReadQueue();
              } else {
                mapAndQueue(value);
              }

              _context25.next = 24;
              break;

            case 18:
              _context25.prev = 18;
              _context25.t0 = _context25["catch"](9);
              ended = true;
              inflightCount--;
              lastError = _context25.t0;
              fulfillReadQueue();

            case 24:
              reading = false;
              fillQueue();

            case 26:
            case "end":
              return _context25.stop();
          }
        }
      }, _callee8, null, [[9, 18]]);
    }));
    return _fillQueue3.apply(this, arguments);
  }

  function mapAndQueue(_x9) {
    return _mapAndQueue2.apply(this, arguments);
  }

  function _mapAndQueue2() {
    _mapAndQueue2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(itrValue) {
      var value;
      return _regeneratorRuntime.wrap(function _callee9$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              _context26.prev = 0;
              _context26.next = 3;
              return func(itrValue);

            case 3:
              value = _context26.sent;
              resultQueue.push(value);
              _context26.next = 11;
              break;

            case 7:
              _context26.prev = 7;
              _context26.t0 = _context26["catch"](0);
              ended = true;
              lastError = _context26.t0;

            case 11:
              inflightCount--;
              fulfillReadQueue();
              fillQueue();

            case 14:
            case "end":
              return _context26.stop();
          }
        }
      }, _callee9, null, [[0, 7]]);
    }));
    return _mapAndQueue2.apply(this, arguments);
  }

  function next() {
    return _next3.apply(this, arguments);
  }

  function _next3() {
    _next3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      var deferred, value;
      return _regeneratorRuntime.wrap(function _callee10$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              if (!(resultQueue.length === 0)) {
                _context27.next = 5;
                break;
              }

              deferred = defer();
              readQueue.push(deferred);
              fillQueue();
              return _context27.abrupt("return", deferred.promise);

            case 5:
              value = resultQueue.shift();
              fillQueue();
              return _context27.abrupt("return", {
                done: false,
                value: value
              });

            case 8:
            case "end":
              return _context27.stop();
          }
        }
      }, _callee10);
    }));
    return _next3.apply(this, arguments);
  }

  var asyncIterableIterator = _defineProperty({
    next: next
  }, Symbol.asyncIterator, function () {
    return asyncIterableIterator;
  });

  return asyncIterableIterator;
}

function transform(concurrency, func, iterable) {
  if (func === undefined) {
    return function (curriedFunc, curriedIterable) {
      return curriedIterable ? transform(concurrency, curriedFunc, curriedIterable) : transform(concurrency, curriedFunc);
    };
  }

  if (iterable === undefined) {
    return function (curriedIterable) {
      return transform(concurrency, func, curriedIterable);
    };
  }

  return _transform(concurrency, func, iterable);
}

function _writeToStream(_x10, _x11) {
  return _writeToStream2.apply(this, arguments);
}

function _writeToStream2() {
  _writeToStream2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(stream, iterable) {
    var e_1, _a, lastError, errCb, drainCb, notifyError, notifyDrain, cleanup, waitForDrain, iterable_1, iterable_1_1, value;

    return _regeneratorRuntime.wrap(function _callee15$(_context32) {
      while (1) {
        switch (_context32.prev = _context32.next) {
          case 0:
            lastError = null;
            errCb = null;
            drainCb = null;

            notifyError = function notifyError(err) {
              lastError = err;

              if (errCb) {
                errCb(err);
              }
            };

            notifyDrain = function notifyDrain() {
              if (drainCb) {
                drainCb();
              }
            };

            cleanup = function cleanup() {
              stream.removeListener('error', notifyError);
              stream.removeListener('drain', notifyDrain);
            };

            stream.once('error', notifyError);

            waitForDrain = function waitForDrain() {
              return new Promise(function (resolve, reject) {
                if (lastError) {
                  return reject(lastError);
                }

                stream.once('drain', notifyDrain);
                drainCb = resolve;
                errCb = reject;
              });
            };

            _context32.prev = 8;
            iterable_1 = __asyncValues(iterable);

          case 10:
            _context32.next = 12;
            return iterable_1.next();

          case 12:
            iterable_1_1 = _context32.sent;

            if (iterable_1_1.done) {
              _context32.next = 22;
              break;
            }

            value = iterable_1_1.value;

            if (!(stream.write(value) === false)) {
              _context32.next = 18;
              break;
            }

            _context32.next = 18;
            return waitForDrain();

          case 18:
            if (!lastError) {
              _context32.next = 20;
              break;
            }

            return _context32.abrupt("break", 22);

          case 20:
            _context32.next = 10;
            break;

          case 22:
            _context32.next = 27;
            break;

          case 24:
            _context32.prev = 24;
            _context32.t0 = _context32["catch"](8);
            e_1 = {
              error: _context32.t0
            };

          case 27:
            _context32.prev = 27;
            _context32.prev = 28;

            if (!(iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return))) {
              _context32.next = 32;
              break;
            }

            _context32.next = 32;
            return _a.call(iterable_1);

          case 32:
            _context32.prev = 32;

            if (!e_1) {
              _context32.next = 35;
              break;
            }

            throw e_1.error;

          case 35:
            return _context32.finish(32);

          case 36:
            return _context32.finish(27);

          case 37:
            cleanup();

            if (!lastError) {
              _context32.next = 40;
              break;
            }

            throw lastError;

          case 40:
          case "end":
            return _context32.stop();
        }
      }
    }, _callee15, null, [[8, 24, 27, 37], [28,, 32, 36]]);
  }));
  return _writeToStream2.apply(this, arguments);
}

function writeToStream(stream, iterable) {
  if (iterable === undefined) {
    return function (curriedIterable) {
      return _writeToStream(stream, curriedIterable);
    };
  }

  return _writeToStream(stream, iterable);
} /// <reference lib="esnext.asynciterable" />


if (Symbol.asyncIterator === undefined) {
  Symbol.asyncIterator = Symbol.for('asyncIterator');
}

export { batch, buffer, collect, concat, consume, filter, flatMap, flatten, flatTransform, fromStream, getIterator, map, merge, parallelFlatMap, parallelMap, parallelMerge, pipeline, reduce, take, tap, time, transform, writeToStream };